module.exports = __webpack_public_path__ + "img/database-schema-copy.a0556c00.svg";